import React from "react";
import GeoIcon from "../../images/geoFlag.svg";

import { Store } from "./_components/Store";

const Home = () => {
  return (
    <div style={styles.div}>
      <h2>Bienvenue sur le site de GéoFlag</h2>
      <img style={styles.icon} src={GeoIcon} alt="GeoFlag" />
      <Store />
    </div>
  );
};

export default Home;

const styles = {
  div: {
    paddingLeft: 15,
    width: "100%",
  },
  icon: {
    width: "20%",
    alignContent: "center",
  },
  deroulement: {
    width: "100%",
  },
};
